import { Icon } from '@chakra-ui/icons';

export const UserIcon = ({ color = 'action' }: { color?: string }) => (
	<Icon
		width="13px"
		height="13px"
		viewBox="0 0 13 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="URL(#clip0_1678_710)">
			<path
				d="M10.166 11.3174V10.3174C10.166 9.78695 9.9553 9.27824 9.58023 8.90317C9.20516 8.5281 8.69645 8.31738 8.16602 8.31738H4.16602C3.63558 8.31738 3.12687 8.5281 2.7518 8.90317C2.37673 9.27824 2.16602 9.78695 2.16602 10.3174V11.3174"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.16602 6.31738C7.27059 6.31738 8.16602 5.42195 8.16602 4.31738C8.16602 3.21281 7.27059 2.31738 6.16602 2.31738C5.06145 2.31738 4.16602 3.21281 4.16602 4.31738C4.16602 5.42195 5.06145 6.31738 6.16602 6.31738Z"
				stroke={color}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1678_710">
				<rect
					width="12"
					height="12"
					fill={color}
					transform="translate(0.166016 0.817383)"
				/>
			</clipPath>
		</defs>
	</Icon>
);
